<div
  class="soft-card soft-card-rounded-m mt-1 mb-2 pr-3 pl-3 pt-3 pb-3 border-box cursor-pointer"
  (click)="tapped.emit(workNote)"
  >
  <div class="flex flex-row justify-between items-center flex-nowrap border-box">
    <div class="flex flex-col justify-center flex-nowrap truncate">
      <span class="soft-overline color-overline mb-1">
        Auftrag {{ workNote?.kopfau?.belegnummer }}{{ workNote?.kopfau?.kundeadresse ? ' - ' + workNote?.kopfau?.kundeadresse : ''}}
      </span>
      <span class="text-md mb-1 font-semibold">
        {{workNote?.bezeichnung}}
        @if (workNote?.belegdatum) {
          - {{$safeNavigationMigration(workNote?.belegdatum) | format:"DATE.DEFAULT"}}
        }
      </span>
      @if (
        workNote?.kopfau?.objekt?.number || workNote?.kopfau?.objekt?.name
        ) {
        <span
          class="text-sm color-light truncate"
          >Objekt {{ workNote?.kopfau?.objekt?.number }} -
          {{ workNote?.kopfau?.objekt?.name }}</span
          >
        }
      </div>

      <div style="min-width: 20px" class="ml-2">
        <i class="fa-regular fa-chevron-right color-lighter"></i>
      </div>
    </div>
  </div>
